export const FALLBACK_PRIVACY_POLICY = 'auctionAccessPrivacyPolicy';

export const normalizeDealership = (dealership = {}) => {
	const source = dealership || {};

	return {
		auctionAccessDealerId: source.auctionAccessDealerId || source.auction_access_dealer_id,
		companyCandidateId: source.companyCandidateId || source.company_candidate_id,
		name: source.name || source.company_name || source.legal_name,
		type: source.type || source.dealership_type,
		address: source.address,
		phoneNumber: source.phoneNumber || source.phone_number,
		dealerLicense: source.dealerLicense || source.dealer_license,
	};
};

export const formatAuctionAccessId = (auctionAccessId) =>
	String(auctionAccessId || '').replace(/(\d{3})(?=\d)/g, '$1 ');

export const formatPhotoIdLastFour = (photoIdLastFour) => `****-** ${photoIdLastFour || ''}`;

export const formatAddress = (address) =>
	[address?.line_one, address?.line_two, address?.city, address?.state, address?.zip].filter(Boolean).join(', ');
